import styled from "styled-components";

import bgMobileSrc from "../../images/hero-bg-mobile.jpg";
import bgDesktopSrc from "../../images/hero-bg-desktop.jpg";

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  overflow: hidden;

  @media (max-width: 1023px) {
    min-height: 772px;
    background-image: url(${bgMobileSrc});
  }

  @media (min-width: 1024px) {
    min-height: 1034px;
    padding-top: 90px;
    background-image: url(${bgDesktopSrc});
  }
`;

export const Container = styled.div`
  display: flex;
  position: relative;
  width: 100%;

  @media (max-width: 1023px) {
    justify-content: center;
  }

  @media (min-width: 1024px) {
    justify-content: space-between;
    max-width: 1920px;
    padding-left: 170px;
    padding-right: 60px;
  }
`;

export const Main = styled.div`
  @media (max-width: 1023px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 475px;
    padding-top: 210px;
    padding-bottom: 20px;
    padding-right: 25px;
    padding-left: 25px;
  }

  @media (min-width: 1024px) {
    padding-top: 240px;
    padding-bottom: 125px;
  }
`;

export const HeroTitle = styled.img`
  width: 100%;

  @media (max-width: 1023px) {
    max-width: 475px;
  }

  @media (min-width: 1024px) {
    max-width: 680px;
  }
`;

export const Call = styled.div`
  width: fit-content;
  text-transform: uppercase;
  transform: rotate(-3deg);

  @media (max-width: 1023px) {
    align-self: flex-start;
    width: 100%;
    max-width: 340px;
    margin-top: 82px;
    margin-bottom: 24px;
  }

  @media (min-width: 1024px) {
    max-width: 550px;
    margin-top: 60px;
    margin-bottom: 50px;
    padding-left: 5px;
  }

  div {
    color: #c49f3f;
    font-family: "Rockwell";

    @media (max-width: 1023px) {
      font-size: 18px;
      line-height: 1.78;
    }

    @media (min-width: 1024px) {
      font-size: 26px;
      line-height: 1.85;
    }
  }

  span {
    color: #fff;
    font-family: "YWFT Ultramagnetic";

    @media (max-width: 1023px) {
      font-size: 24px;
      line-height: 1.25;
    }

    @media (min-width: 1024px) {
      font-size: 40px;
      line-height: 1.2;
    }
  }

  sup {
    @media (max-width: 1023px) {
      font-size: 14px;
    }

    @media (min-width: 1024px) {
      font-size: 22px;
    }
  }
`;

export const Note = styled.p`
  color: #c3c3c3;
  font-size: 14px;
  line-height: 1.71;

  @media (max-width: 1023px) {
    margin-top: 25px;
  }

  @media (min-width: 1024px) {
    max-width: 550px;
    margin-top: 65px;
  }

  button {
    display: inline-block;
    margin: 0;
    padding: 0;
    color: #fff;
    background-color: transparent;
    font-family: inherit;
    text-decoration: underline;
  }
`;
